<template>
  <q-checkbox dense :rules="outputRules" :disable="disableComputed || readonlyComputed">
    <template v-for="(slot, name) in $slots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope ?? {}" />
    </template>
  </q-checkbox>
</template>

<script setup>
import { computed } from "vue"

import { useValidators } from "@/composables/useValidators.js"
import { useFieldsetState } from "@/composables/useFieldsetState.js"

const validators = useValidators()

const props = defineProps({
  required: Boolean,
  disable: Boolean,
  readonly: Boolean,
  alwaysValidate: Boolean
})

const { disableComputed, readonlyComputed, validationSkipped } = useFieldsetState(props)

const outputRules = computed(() => {
  if (validationSkipped.value) {
    return []
  }
  const rules = props.rules ? [...props.rules] : []
  if (props.required) {
    rules.push(validators.required)
  }
  return rules
})
</script>
